import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, ROLES } from "../context/AuthContext";

/**
 * Central navigation helpers used across the public landing / dashboards.
 *
 * comingSoon(label)    → notifies the user that the feature is not yet
 *                        available (respects the "En préparation" contract).
 * goToRoleSpace(role)  → smart CTA used on persona cards. If the visitor is
 *                        authenticated → dashboard. Otherwise → login screen
 *                        pre-selecting the chosen role.
 * goToDashboard()      → shortcut used on generic CTAs.
 */
export function useAppNavigation() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const comingSoon = useCallback((label) => {
    toast(`${label} — En préparation`, {
      description:
        "Cette fonctionnalité sera activée lors du déploiement pilote v1.0 (roadmap Q2 2026).",
      duration: 3200,
    });
  }, []);

  const goToRoleSpace = useCallback(
    (role) => {
      if (user) {
        navigate("/dashboard");
      } else {
        const targetRole =
          role && Object.values(ROLES).includes(role) ? role : ROLES.TALENT;
        navigate(`/login?mode=signup&role=${encodeURIComponent(targetRole)}`);
      }
    },
    [user, navigate]
  );

  const goToDashboard = useCallback(() => {
    if (user) navigate("/dashboard");
    else navigate("/login");
  }, [user, navigate]);

  return { comingSoon, goToRoleSpace, goToDashboard };
}
